import React from 'react';
import './spinners.scss';

export const Spinner = ({ color = '#fff' }: { color?: string }) => (
  <div className="lds-ring">
    <div
      style={{ borderColor: `${color} transparent transparent transparent` }}
    />
    <div
      style={{ borderColor: `${color} transparent transparent transparent` }}
    />
    <div
      style={{ borderColor: `${color} transparent transparent transparent` }}
    />
    <div
      style={{ borderColor: `${color} transparent transparent transparent` }}
    />
  </div>
);

export const BeatLoader = ({ color = 'gray-700' }: { color?: string }) => (
  <div className="lds-ellipsis">
    <div className={`bg-${color}`} />
    <div className={`bg-${color}`} />
    <div className={`bg-${color}`} />
    <div className={`bg-${color}`} />
  </div>
);
